export type CSSUnits = "px" | "%";

export function isCSSUnits(value: string): value is CSSUnits {
    return ["px", "%"].includes(value);
}
